import { StatusTag } from '../crop-circle/Components/Tag';

export const SubHeaderText = ({ children }: { children: React.ReactNode }) => {
  return <StatusTag text={`${children}`} variant="neutral" />;
};
